import type { AgoraRTCReactError } from 'agora-rtc-react';

export function isPermissionDeniedError(error: Error) {
  return /permission\sdenied/i.test(error.message) || /not\sallowed/i.test(error.message);
}

export function isRateLimitError(error: Error) {
  return /rate\slimit/i.test(error.message);
}

export function rtcErrorOf(error: AgoraRTCReactError) {
  if (typeof error.rtcError === 'string') {
    return { code: error.rtcError, data: undefined };
  }

  return error.rtcError;
}

export function isCaptureRefused(error: AgoraRTCReactError) {
  return rtcErrorOf(error)?.code === 'PERMISSION_DENIED';
}

const ABSENT_DEVICE = ['NotFoundError', 'OverconstrainedError'];

export function errorNameOf(error: unknown): string | undefined {
  const name = (error as { name?: unknown } | null)?.name;
  if (typeof name === 'string') {
    return name;
  }

  return undefined;
}

export function isDeviceAbsent(error: unknown) {
  const name = errorNameOf(error);

  return name !== undefined && ABSENT_DEVICE.includes(name);
}

export function isBrowserRefusal(error: unknown) {
  return errorNameOf(error) === 'NotAllowedError';
}

export function isMicrophoneRefusal(error: unknown) {
  if (isBrowserRefusal(error)) {
    return true;
  }

  return Boolean((error as { rtcError?: unknown } | null)?.rtcError) && isCaptureRefused(error as AgoraRTCReactError);
}
